import React from 'react'
import AppointmentEdit from "./AppointmentEdit";
import AppointmentDelete from "./AppointmentDelete";
import AppointmentDetails from "./AppointmentDetails";

const AppointmentActions = ({record, updater}) => {

    return(
        <React.Fragment>
            <AppointmentEdit appointment={record} updater={updater} />
            <AppointmentDelete appointmentId={record.id} updater={updater} />
            <AppointmentDetails appointmentId={record.id} />
        </React.Fragment>
    )
}
export default AppointmentActions